<template>
    <button class="my-btn" :class="type">
        <slot></slot>
    </button>
</template>

<script lang="ts">
import { Vue, Prop, Component } from "vue-property-decorator";

@Component({
    name: 'SimpleButton',
})
export default class SimpleButton extends Vue {
    @Prop()
    type: String | undefined;
}
</script>

<style lang="scss" scoped>
.my-btn {
    max-width: 100px;
    width: 100%;
    height: 44px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 600;
    border: none;
}

.my-btn:focus {
    outline: none;
}

.primary {
    color: #FFFFFF;
    background-color: #00D393;
}

.secondary {
    color: #2289E9;
    background-color: transparent;
}
</style>
